import { FC } from 'react';
import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';

type ConfirmResendTeamMemberInviteModalProps = {
  isOpen: boolean;
  setClosed: () => void;
  onConfirm: () => void;
  isResending: boolean;
  isExternalCollaborator?: boolean;
};

const ConfirmResendTeamMemberInviteModal: FC<
  ConfirmResendTeamMemberInviteModalProps
> = ({
  isOpen,
  setClosed,
  onConfirm,
  isResending,
  isExternalCollaborator = false,
}) => {
  return (
    <Modal isOpen={isOpen} setClosed={setClosed} width="small">
      <div className="px-10 py-8">
        <div className="flex flex-col items-center">
          <div className="mb-2 flex text-center font-serif text-subtitle-small text-green-150">
            Would you like to resend the invitation to this{' '}
            {isExternalCollaborator ? 'collaborator' : 'team member'}?
          </div>
          <div className="text-center text-body text-neutral-125">
            {isExternalCollaborator
              ? 'A new invitation will be sent to the collaborator to gain access to your team.'
              : 'A new invitation will be sent to the team member to join your team.'}
          </div>
        </div>
        <div className="mt-11 flex w-full flex-row items-center justify-center">
          <Button
            title="Cancel"
            theme="secondary"
            className="mr-5"
            onClick={setClosed}
          />
          <Button
            title="Send another invite"
            theme="primary"
            onClick={onConfirm}
            disabled={isResending}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmResendTeamMemberInviteModal;
